import { render, staticRenderFns } from "./ProductMerchants.vue?vue&type=template&id=ce726c9c&scoped=true&name=product-merchants&"
import script from "./ProductMerchants.vue?vue&type=script&lang=js&"
export * from "./ProductMerchants.vue?vue&type=script&lang=js&"
import style0 from "./ProductMerchants.vue?vue&type=style&index=0&id=ce726c9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce726c9c",
  null
  
)

/* custom blocks */
import block0 from "./ProductMerchants.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports